import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";

export default function ThankYouPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto space-y-8">
        <div className="text-center">
          <img src="/logo.webp" alt="Logo" className="mx-auto h-24 w-auto" />
          <h1 className="mt-6 text-3xl font-bold text-gray-900">
            Vielen Dank für Ihr Interesse!
          </h1>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Ihre Anfrage wurde erfolgreich übermittelt</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600">
              Wir haben Ihre Daten erhalten und werden uns zeitnah mit Ihnen in Verbindung setzen.
              Falls Sie noch Fragen haben, können Sie uns gerne kontaktieren.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
} 